// -----------------------------------------------------------------------------
// API client for layout variants (Phase 8 Wave 8.E).
// -----------------------------------------------------------------------------

import { apiFetch } from '../../../api/client';
import { Endpoints } from '../../../api/types';

/** Mirrors `DocumentRegion` enum on the server (subset surfaced in the UI hint map). */
export type DocumentRegionName =
  | 'Unknown'
  | 'Header'
  | 'Footer'
  | 'BodyLeft'
  | 'BodyCenter'
  | 'BodyRight'
  | 'Table'
  | 'Signature';

export interface LayoutVariantResponse {
  id: string;
  tenantId: string;
  documentTypeId: string;
  name: string;
  fieldRegions: Record<string, DocumentRegionName>;
  signature: string;
  createdAt: string;
  updatedAt: string;
}

export interface AddLayoutVariantBody {
  name: string;
  exemplarJobId: string;
  fieldRegions: Record<string, DocumentRegionName>;
}

function variantsBase(slug: string): string {
  return `${Endpoints.documentTypes}/${encodeURIComponent(slug)}/variants`;
}

export function listLayoutVariants(slug: string, signal?: AbortSignal): Promise<LayoutVariantResponse[]> {
  return apiFetch<LayoutVariantResponse[]>(variantsBase(slug), signal !== undefined ? { signal } : {});
}

export function addLayoutVariant(slug: string, body: AddLayoutVariantBody): Promise<LayoutVariantResponse> {
  return apiFetch<LayoutVariantResponse>(variantsBase(slug), { method: 'POST', json: body });
}

export function removeLayoutVariant(slug: string, variantId: string): Promise<null> {
  return apiFetch<null>(`${variantsBase(slug)}/${encodeURIComponent(variantId)}`, { method: 'DELETE' });
}

export const LayoutVariantQueryKeys = {
  list: (slug: string): readonly unknown[] => ['layout-variants', slug],
} as const;
